import React from 'react';
import {CBCButton} from 'shared/helpers';
import styled from 'styled-components';
import {useCancelButton} from 'shared/components/CancelButton/helper/useCancelButton';
import {size, mobileLandscapeAndPortraitDevices} from 'shared/Breakpoints';
import {PDFReportButtons} from 'components/customer/Confirmation/PDFReportButtons';
import {useResetJob} from 'components/customer/Confirmation/helpers/useResetJob';

export const ControlButtons = ({
    smallDevice = false,
}: {
    smallDevice?: boolean;
}) => {
    const {handleResetJob} = useResetJob();
    const {handleCancelClick} = useCancelButton({
        noDialog: true,
        beforeRedirect: handleResetJob,
    });

    return (
        <ButtonsContainer $smallDevice={smallDevice}>
            <PDFReportButtons />
            <CBCButton
                type="submit"
                iconName="Button-Previous.svg"
                className="job-button button-blue"
                onClick={handleCancelClick}>
                Back to ordering
            </CBCButton>
        </ButtonsContainer>
    );
};

const ButtonsContainer = styled.div<{$smallDevice: boolean}>`
    flex-direction: column;
    gap: 15px;
    margin-bottom: 15px;
    padding: 0 15px;

    display: ${({$smallDevice = true}) => ($smallDevice ? 'none' : 'flex')};

    @media (max-width: ${size.sm - 1}px) {
        display: ${({$smallDevice = true}) => ($smallDevice ? 'flex' : 'none')};
        flex-direction: row-reverse;
        margin: 15px 0 0;
        padding: 0;

        > a,
        > button {
            padding: 3px;
            height: 40px;
            font-size: 0.85em;
        }
    }

    ${mobileLandscapeAndPortraitDevices`
        display: none;    
    `}
`;
